import { render, staticRenderFns } from "./TypeExpeditionStatusForm.vue?vue&type=template&id=5fdc730c&"
import script from "./TypeExpeditionStatusForm.vue?vue&type=script&lang=js&"
export * from "./TypeExpeditionStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports